var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main-wrapper"}},[_c('Sidebar'),_c('RouterView',{key:_vm.$route.path,attrs:{"toPath":_vm.toRoute?.path,"fromPath":_vm.fromRoute?.path}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }